import React, { useState,useEffect} from 'react';
import { Modal as UxfModal, Form, Button, CloseButton } from '@deere/ux.uxframe-react'
import { MODAL_DESELECT_BUTTON_TEXT, MODAL_DESELECT_TITLE, MODAL_DESELECT_WARNING_MESSAGE, MODAL_PROPIETARY_TITLE, MODAL_REASON_MESSAGE } from '../utils/surveyLiterals'
import CustomAlert from './CustomAlert';
import { updateSurveyAnswers, removeSurveyAnswer } from '../redux/action/surveyAction';
import { findAnswerIndex } from '../utils/utils';
import store from '../redux/store'
import { useDispatch} from 'react-redux';
import { useTranslation } from "react-i18next";
import {DebounceInput} from 'react-debounce-input';

export default function Modal({ warning, show, handleClose, handleSave, propQuestion }) {
    const [answers, setAnswers] = useState([])
    const [saveBtn, setSaveBtn] = useState(true)
    const [comment, setComment] = useState()
    const dispatch = useDispatch()
    const { t } = useTranslation();


    function updateAnswer(e){
        (e.target.value!=='')?setSaveBtn(false):setSaveBtn(true);
        setComment(e.target.value);        
    }
    
    function saveAnswer(e){ 
        dispatch(updateSurveyAnswers({ questionId: propQuestion, answer: comment }));        
        setAnswers([...store.getState().survey.surveyAnswers])        
        handleSave(e);
    }

    function deselectAnswer(e){
        setSaveBtn(true)
        dispatch(removeSurveyAnswer(propQuestion));
        setAnswers([...store.getState().survey.surveyAnswers])        
        handleSave(e);
    }

    function cancel(e){
        setSaveBtn(true)
        handleClose(e)
    }

    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers])
    }, [])
    
    return (
        <div>
            <UxfModal size='lg' show ={show}>
                <>
                    <UxfModal.Header>
                        <UxfModal.Title>
                            {
                                warning ? MODAL_DESELECT_TITLE : MODAL_PROPIETARY_TITLE
                            }
                        </UxfModal.Title>
                        <CloseButton onClick={(e) => cancel(e)} />
                    </UxfModal.Header>
                    <UxfModal.Body className="overflow-hidden">
                        <Form.Group controlId="textarea-example">
                            <Form.Label>
                                {
                                    warning ? null : <h5>{t('proprietary_popup_reason')} <span aria-label="required field" className="uxf-is-required">*</span>{t('proprietary_popup_subtext')}</h5>
                                }
                            </Form.Label>
                            {
                                warning ? <CustomAlert accessibilityLabel='Warning:' variant='warning' title={MODAL_DESELECT_WARNING_MESSAGE} />
                                    : <DebounceInput element="textarea" rows="5" aria-describedby="textarea-text" className="form-control" debounceTimeout={300}
                                        onChange={(e) => updateAnswer(e)}
                                        placeholder={MODAL_REASON_MESSAGE}
                                        value= {findAnswerIndex(propQuestion, answers) >= 0 ? answers[findAnswerIndex(propQuestion, answers)].answer : ''}/>
                            }
                        </Form.Group>
                    </UxfModal.Body>
                    <UxfModal.Footer>
                        <Button onClick={(e) => cancel(e)} variant="secondary">{t('btn_cancel')}</Button>
                        {
                            warning ? <Button variant="primary" onClick={(e) => deselectAnswer(e)}>{MODAL_DESELECT_BUTTON_TEXT}</Button> : <Button id="save" onClick={saveAnswer} disabled={saveBtn} variant="primary">{t('btn_save_survey')}</Button>
                        }
                    </UxfModal.Footer>
                </>
            </UxfModal>
        </div>
    )
}